import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/PublicDataPage.css";

const PublicDataPage = () => {
  const navigate = useNavigate();

  const cards = [
    {
      title: "SRA Data",
      description: "Download public sequencing data from NCBI SRA.",
      onClick: () => navigate("/import-sra"),
      comingSoon: false,
    },
    {
      title: "GDC Data",
      description: "Download open-access TCGA / TARGET / Pan-Cancer files.",
      onClick: () => navigate("/import-gdc"),
      comingSoon: false,
    },
    {
      title: "1000 Genomes",
      description: "Browse and download public files by sample from the 1000 Genomes Project.",
      onClick: () => navigate("/import-1000g"),
      comingSoon: false,
    },
    {
      title: "UCSC Data",
      description: "Browse UCSC genome assemblies (goldenPath) and download reference & annotation files.",
      onClick: () => navigate("/import-ucsc"),
      comingSoon: false,
    },
    {
      title: "Ensembl Data",
      description: "Browse Ensembl & Ensembl Genomes (plants, fungi, metazoa, bacteria…) and download files.",
      onClick: () => navigate("/import-ensembl"),
      comingSoon: false,
    },
    {
      title: "Custom URLs",
      description: "Paste any public file URLs and download them into a project. Billed by downloaded size.",
      onClick: () => navigate("/import-url"),
      comingSoon: false,
    },
  ];

  return (
    <div className="publicdata-container">
      <h1>Download Public Data</h1>

      <div className="publicdata-toolbar">
        <button className="publicdata-previous-btn" onClick={() => navigate("/downloads")}>
          Previous Downloads
        </button>
      </div>

      <div className="publicdata-grid">
        {cards.map((card) => (
          <div
            key={card.title}
            className={`publicdata-card ${card.comingSoon ? "disabled" : ""}`}
            onClick={!card.comingSoon ? card.onClick : undefined}
          >
            <h2>{card.title}</h2>
            <p>{card.description}</p>

            {card.comingSoon && (
              <div className="publicdata-comingsoon">Coming Soon</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PublicDataPage;
